import {
  MIN_LENGTH,
  REQUIRED,
  MAX_LENGTH,
  MIN_VALUE,
  MAX_VALUE,
  EMAIL,
  SITE,
  EMAILS,
  ESPECIAL_CHARACTER,
  NOT_NULL,
  URL,
  EMPTY
} from "./methods";

/**
 * Return the mapped function validaiton according the method passed by parameter
 * and value to compare
 *
 * @param {string const} method
 * @param {string|number, optional} value
 * @returns Function
 */
export const getValidationMethod = (method, value) => {
  switch (method) {
    case REQUIRED:
      return (v) => !!v;
    case MIN_LENGTH:
      return (v) => v.length >= value;
    case MAX_LENGTH:
      return (v) => v.length <= value;
    case MIN_VALUE:
      return (v) => v >= value;
    case MAX_VALUE:
      return (v) => v <= value;
    case SITE:
      return (v) => {
        // eslint-disable-next-line no-useless-escape
        var re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
        return re.test(v);
      };
    case EMAIL:
      return (v) => {
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return re.test(String(v).toLowerCase());
      };
    case EMAILS:
      return (v) => {
        let valid = true;
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        for (let i = 0; i < v.length; i++) {
          if (!re.test(String(v[i]).toLowerCase())) {
            valid = false;
          }
        }
        return valid;
      };
    case ESPECIAL_CHARACTER:
      return (v) => {
        let valid = true;
        const re = /^[a-zA-Z0-9]+$/;
        for (let i = 0; i < v.length; i++) {
          if (!re.test(String(v[i]).toLowerCase())) {
            valid = false;
          }
        }
        return valid;
      };
    case NOT_NULL: {
      return (v) => v !== null;
    }
    case URL:
      return (v) => v.substring(0, 7) === "http://" || v.substring(0, 8) === "https://";
    case EMPTY:
      return (v) => v.trim() === "";
  }
};

export const validate = (method, value, comparator) => {
  return getValidationMethod(method, comparator)(value);
};
